<ngx-simplebar class="px-3 mx-n3 mb-2" style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
  [options]="{ forceVisible: true }">
  <div class="card">
    <div class="card-body">
      <input hidden type="file" (change)="onFileChange($event)" id="input-file-doc" multiple
        *ngIf="canAddDocuments"
        accept="application/pdf,image/png,image/jpg,image/jpeg,.kmz,application/vnd.google-earth.kmz,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" />

      <ng-container *ngFor="let section of documentSections; trackBy: trackByDocumentSection">
        <ng-container *ngIf="shouldShowDocumentSection(section)">
          <div class="separator my-2">
            <span class="separator-text">
              {{ section.label | translate }}
              <i class="ri-question-line ms-1" [ngbTooltip]="section.tooltip | translate" placement="top"
                container="body"></i>
            </span>
          </div>

          <div class="row mb-3">
            <div class="col-12">
              <button type="button" class="btn btn-outline-primary float-end btn-sm"
                (click)="addDoc(section.visibility)" *ngIf="canAddDocuments">
                + {{'t-add'|translate}} {{'t-m-properties.t-documents'|translate|lowercase}}
              </button>
            </div>
          </div>

          <ng-container *ngIf="documentsByVisibility[section.visibility] as sectionDocs">
            <div class="row mb-4" *ngIf="sectionDocs.length > 0">
              <div class="col-12">
                <div class="table-card mt-3 mb-0">
                  <table class="table table-borderless align-middle mb-0 documents-table">
                    <thead class="table-light">
                      <tr>
                        <th scope="col" class="document-file-column">{{'t-m-properties.t-file-name'|translate}}</th>
                        <th scope="col"
                          [ngClass]="section.visibility === 'COMMERCIAL' ? 'document-description-commercial-column' : 'document-description-column'">
                          {{'t-m-properties.t-description'|translate}}
                        </th>
                        <th scope="col" class="document-website-column" *ngIf="section.visibility === 'COMMERCIAL'">
                          {{'t-m-properties.t-show-on-website'|translate}}
                          <i class="ri-question-line ms-1"
                            [ngbTooltip]="'t-m-properties.t-show-on-website-tooltip' | translate" placement="top"
                            container="body"></i>
                        </th>
                        <th scope="col" class="document-type-column">{{'t-m-properties.t-type'|translate}}</th>
                        <th scope="col" class="document-size-column">{{'t-m-properties.t-size'|translate}}</th>
                        <th scope="col" class="document-date-column">{{'t-created-at'|translate}}</th>
                        <th scope="col" class="document-actions-column">{{'t-action'|translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let data of sectionDocs; trackBy: trackByDocument">
                        <td>
                          <div class="d-flex align-items-center document-file-cell">
                            <div class="avatar-xs">
                              <div class="avatar-title bg-light rounded fs-24"
                                [ngClass]="documentIconColor(data)">
                                <i [ngClass]="documentIconName(data)">
                                </i>
                              </div>
                            </div>
                            <div class="ms-3 flex-grow-1 document-file-name-wrap">
                              <h5 class="fs-14 mb-0">
                                <a href="javascript:void(0)" class="text-dark document-file-name"
                                  [ngStyle]="{'pointer-events': !data.isNew ? null : 'none', 'cursor': !data.isNew ? 'pointer' : 'default'}"
                                  (click)="previewDocument(data)">{{data.name}}</a>
                              </h5>
                            </div>
                          </div>
                        </td>
                        <td class="text-break">{{getDocumentDescription(data)}}</td>
                        <td class="text-center" *ngIf="section.visibility === 'COMMERCIAL'">
                          <input class="form-check-input" type="checkbox" [(ngModel)]="data.showOnWebsite"
                            [ngModelOptions]="{standalone: true}" [disabled]="!canEditDocument(data)" />
                        </td>
                        <td class="text-nowrap">{{ resolveFileType(data) }}</td>
                        <td class="text-nowrap">{{formatSizeUnits(data.size)}}</td>
                        <td class="text-nowrap">{{createDateFormat(data.createdAt)}}</td>
                        <td>
                          <div class="dropdown" ngbDropdown
                            [ngStyle]="{'cursor': permissionsService.canEditProperty(loginUser, property?.store?.id) || data.isNew || !property?null:'not-allowed'}">
                            <a href="javascript:void(0);" class="btn btn-soft-primary btn-sm btn-icon arrow-none"
                              ngbDropdownToggle
                              [ngStyle]="{'pointer-events': canUseDocumentActions(data)?null:'none'}">
                              <i class="ri-more-fill"></i>
                            </a>

                            <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu
                              *ngIf="canUseDocumentActions(data)">
                              <li *ngIf="canEditDocument(data)">
                                <a class="dropdown-item " href="javascript:void(0);" (click)="editDocument(data)">
                                  <i class="ri-pencil-fill me-2 align-bottom text-muted"></i>
                                  {{'t-m-properties.t-edit-description'|translate}}
                                </a>
                              </li>

                              <ng-container *ngIf="canEditDocument(data)">
                                <li class="dropdown-divider"></li>
                                <li *ngFor="let moveSection of moveDocumentSectionsByVisibility[section.visibility]">
                                  <a class="dropdown-item" href="javascript:void(0);"
                                    (click)="moveDocumentToVisibility(data, moveSection.visibility)">
                                    <i class="ri-arrow-left-right-line me-2 align-bottom text-muted"></i>
                                    {{'t-move-to'|translate}} {{ moveSection.label | translate }}
                                  </a>
                                </li>
                              </ng-container>

                              <li *ngIf="canConsultDocument(data)">
                                <a class="dropdown-item" href="javascript:void(0);" (click)="previewDocument(data)">
                                  <i class="ri-eye-line me-2 align-bottom text-muted"></i>
                                  {{'t-preview'|translate}}
                                </a>
                              </li>
                              <li *ngIf="canConsultDocument(data)">
                                <a class="dropdown-item" href="javascript:void(0);" (click)="openDocumentQuickly(data)">
                                  <i class="ri-external-link-line me-2 align-bottom text-muted"></i>
                                  {{'t-open-in-new-tab' | translate}}
                                </a>
                              </li>
                              <li *ngIf="canDownloadDocument(data)">
                                <a class="dropdown-item" href="{{data.path}}">
                                  <i class="ri-download-2-fill me-2 align-bottom text-muted"></i>
                                  {{'t-download'|translate}}
                                </a>
                              </li>
                              <li *ngIf="canDeleteDocument(data)" class="dropdown-divider"></li>
                              <li *ngIf="canDeleteDocument(data)">
                                <a class="dropdown-item" (click)="deleteDoc(data)" href="javascript:void(0);">
                                  <i
                                    class="ri-delete-bin-5-fill me-2 align-bottom text-muted"></i>{{'t-delete'|translate}}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ngx-simplebar>
